import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import React, { useEffect, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { QuotationSummaryData } from '../../../../models/quotations/Quotations';
import { CommentTemplate } from '../../../shared/CommentTemplate';
import TextFieldStyled from '../../../shared/TextFieldStyled';
import { QuotationFormItemWrapper } from '../../shared/QuotationFormItemWrapper';
import { QuotationFormRowWrapper } from '../../shared/QuotationFormRowWrapper';
import { QuotationSummaryTitle } from '../../shared/QuotationSummaryTitle';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { OutlinedButton } from '../../../styled/OutlinedButton';
import { AddUpdateCommentTemplate } from '../../../comment-templates/AddUpdateCommentTemplateModal';
import useGeneralDialog from '../../../../hooks/dialogs/useGeneralDialog';
import type { CommentTemplateRefProps } from '../../../../models/CommentTemplate';

export const QuotationSummaryPDF: React.FC<{
    quoteData: QuotationSummaryData;
    changeNote: React.Dispatch<React.SetStateAction<string>>;
    changeLogo: React.Dispatch<React.SetStateAction<boolean>>;
}> = (props) => {
    const { changeNote, changeLogo, quoteData } = props;
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.SUMMARY.PDF',
    });


    const { t: ot } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.FIELDS.QUOTATION_DETAILS',
    });

    const { control, setValue, getValues } = useForm<{
        comment_2: string;
    }>();

    const handleTemplateAdd = (value: string) => {
        const newValue = (getValues('comment_2') + ' ' ?? '') + value;

        setValue('comment_2', newValue, { shouldDirty: true });

        changeNote(newValue);
    };

    const commentRef = useRef<CommentTemplateRefProps>(null);

    const theme = useTheme();

    const dialog = useGeneralDialog();

    const small = useMediaQuery(theme.breakpoints.down('md'));

    const handleOpenCreateNewCommentDialog = (): void => {
        dialog.showDialog({
            title: ot('ADD_NEW.TITLE', {
                keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.COMMENT_TEMPLATE',
            }),
            confirmLabel: ot('ADD_NEW.CONFIRM', {
                keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.COMMENT_TEMPLATE',
            }),
            closeLabel: ot('ADD_NEW.CANCEL', {
                keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.COMMENT_TEMPLATE',
            }),
            preSetContent: { note: getValues('comment_2'), title: '' },
            component: AddUpdateCommentTemplate,
            onCloseWithSuccess: commentRef.current?.refresh,
        });
    };

    useEffect(() => {
        setValue('comment_2', quoteData.comment_2 ? quoteData.comment_2 : '');
    }, []);

    return (
        <>
            <div style={{ marginTop: '10px' }}>
                {/*<QuotationSummaryTitle>{t('TITLE')}</QuotationSummaryTitle>*/}
                <form>
                    <QuotationFormRowWrapper>
                        <QuotationFormItemWrapper>
                            <DemoItem label={t('FOOTER_NOTE')}>
                                <Controller
                                    name="comment_2"
                                    control={control}
                                    render={({ field }) => (
                                        <TextFieldStyled
                                            sx={{
                                                backgroundColor: 'white',
                                                '& .MuiFilledInput-input': {
                                                    padding: '0px !important',
                                                },
                                                '& .MuiFilledInput-root': {
                                                    minHeight: '50px',

                                                    padding:
                                                        '5px 5px 5px 5px !important',
                                                    '@media (max-width: 600px)':
                                                        {
                                                            padding:
                                                                '2px 0px 2px 5px !important',
                                                        },
                                                },
                                            }}
                                            multiline
                                            minRows={5}
                                            maxRows={8}
                                            hiddenLabel
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                changeNote(e.target.value);
                                            }}
                                        />
                                    )}
                                />
                            </DemoItem>

                            <Stack alignItems="flex-start">
                                <OutlinedButton
                                    sx={{
                                        width: small ? '100%' : 'auto',
                                        margin: '12px 0',
                                        height: '40px',
                                    }}
                                    onClick={handleOpenCreateNewCommentDialog}
                                >
                                    {ot('ADD_NEW_COMMENT_TEMPLATE')}
                                </OutlinedButton>
                            </Stack>
                        </QuotationFormItemWrapper>
                        <QuotationFormItemWrapper>
                            <CommentTemplate
                                handleCommentSelect={handleTemplateAdd}
                                title={t('NOTE')}
                                ref={commentRef}
                            />
                        </QuotationFormItemWrapper>
                    </QuotationFormRowWrapper>
                </form>
            </div>
        </>
    );
};
